import * as React from 'react';
import CheckBox from 'shared/components/CheckBox';
import RadioBox from 'shared/components/RadioBox';
import Input from 'shared/components/Input';

const Forms = () => {
  return (
    <div className='row'>
      <div className='col-4'>
        <Input label='Email address' placeholder='Type here' />
      </div>
      <div className='col-4'>
        <Input label='Email address' placeholder='Type here' errorText='Lorem ipsum dolor' />
      </div>
      <div className='col-4'>
        <CheckBox label='Custom checkbox' id='check1' />
        <RadioBox label='Custom radio' id='radio1' />
      </div>
    </div>
  );
};

export default Forms;
